import React from 'react'
import './about.css'
import ME2 from '../../assets/about.jpg'
import {FaAward, FaUsers, FaFolderOpen} from 'react-icons/fa'

const About = () => {
    return (
        <section id="about">
            <h5>Get To Know</h5>
            <h2>About Me</h2>
            <div className="container about__container">
                    <div className="about__me">
                        <div className="about__me-image">
                            <img src={ME2} alt="ME"/>
                        </div>
                    </div>
                <div className="about__content">
                        <div className="about__cards">
                            <article className="about__card">
                                <FaAward className="about__icon"/>
                                <h5>Personal approach</h5>
                                <small>A creative look and a pleasant environment will make your photo shoot enjoyable.</small>
                            </article>
                            <article className="about__card">
                                <FaUsers className="about__icon"/>
                                <h5>Best quality</h5>
                                <small>Naturally edited photos of the best quality in high digital format.</small>
                            </article>
                            <article className="about__card">
                                <FaFolderOpen className="about__icon"/> 
                                <h5>Pricing&Speed</h5>
                                <small>Transparent pricing,great availability and a fast photo delivery.It takes me 3-5 days to complete the order.</small>
                            </article>
                        </div>
                        <p>Welcome to Anastasiia's world of captivating photography. 
                            With a passion for storytelling and a keen eye for detail,I
                            craft images that transcend the ordinary, capturing the essence of 
                            life's most beautiful moments. From intimate portraits to breathtaking 
                            landscapes, each photograph is a masterpiece, meticulously composed and 
                            expertly edited to evoke emotion and tell a story.My technical 
                            proficiency, creative vision, and dedication to authenticity shine through in 
                            every image, creating a portfolio that is as diverse as it is captivating. 
                            Join me on a visual journey filled with beauty, emotion, and endless 
                            inspiration.</p>
                        <a href="#contact" className="btn btn-primary">Contact Me</a>
                </div>
            </div>
        </section>
    )
}
export default About
